import { Box, Stack, styled, Typography } from '@mui/material';

export const ComponentEditContainer = styled(Box)`
  display: flex;
  flex: 1;
  height: 100vh;
  flex-direction: row;
  padding: 0 !important;
`;

export const ComponentEditSideMenuContainer = styled(Box)`
  position: relative;
  width: 400px;
`;

export const HeaderContainer = styled(Box)`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 20px 14px 20px 30px;
  align-items: flex-start;
`;

export const ActionButtonsContainer = styled(Stack)`
  margin-right: 20px;
  flex-shrink: 0;
`;

export const ComponentEditContentContainer = styled(Box)(
  ({ theme }) => `
  display: flex;
  flex: 1;
  flex-direction: column;
  border-left: 1px solid ${theme.palette.secondary.light};
  overflow: auto;
`,
);

export const ComponentNameText = styled(Typography)`
  padding-right: 16px;
`;
